import { render, staticRenderFns } from "./WorkflowModelPickerModal.vue?vue&type=template&id=4c5fc381&scoped=true"
import script from "./WorkflowModelPickerModal.vue?vue&type=script&lang=js"
export * from "./WorkflowModelPickerModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowModelPickerModal.vue?vue&type=style&index=0&id=4c5fc381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5fc381",
  null
  
)

export default component.exports